module.exports = __webpack_public_path__ + "static/media/kfc-delivery.841491e7.jpg";